import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import { ApolloProvider } from 'react-apollo';
import { IntlProvider } from 'react-intl';
import App from './App';
import store from './store';
import client from './apollo';
import { unregister } from './registerServiceWorker';
import validatorAttributeFormatter from './validatorAttributeFormatter';
import { fetchFeatureFlags } from './data/featureFlags/actions';
import './assets/react-datepicker-fix.css';
import './assets/semantic-ui-fix.css';
import './assets/css-variables.css';
import './assets/theme.css';

const container = document.getElementById('ds-admin-root');
const root = createRoot(container);

// Load DB feature flags into Redux in the background (never blocks first paint).
// Refetched after sign-in from the login flow, since a new JWT is issued then.
store.dispatch(fetchFeatureFlags());

root.render(
  <IntlProvider locale='en'>
    <Provider store={store}>
      <ApolloProvider client={client}>
        <HashRouter>
          <App />
        </HashRouter>
      </ApolloProvider>
    </Provider>
  </IntlProvider>
);

unregister();
validatorAttributeFormatter();
